import { formatTime } from '../../../utils';

/**
 * Normaliza y extrae las propiedades de cualquier mensaje entrante o saliente
 * @param {object} msg 
 * @param {number} index 
 * @returns {object}
 */
export const parseMessageData = (msg, index) => {
  const isAgent = Boolean(msg.bEsAgente);
  const text = msg.vTextoMensaje || '';
  const id = msg.idMensaje || index;
  const timeStr = formatTime(msg.dCreatedDate) || '';
  const mimeType = (msg.vMediaMimeType || '').toLowerCase();

  const rawTipoId = msg.idCatTipoMensaje;
  const isSticker = rawTipoId === 3 || mimeType.includes('webp') || text === '[sticker]';
  const isImage = rawTipoId === 2 || (!isSticker && (mimeType.startsWith('image/') || text === '[image]'));
  const isAudio = rawTipoId === 4 || mimeType.startsWith('audio/') || text === '[audio]';
  const isVideo = rawTipoId === 5 || mimeType.startsWith('video/') || text === '[video]';
  const isDocument = rawTipoId === 6 || mimeType.startsWith('application/') || mimeType.startsWith('text/') || text === '[document]';
  const isContact = rawTipoId === 8;

  const mediaId = msg.vMediaId;
  const mediaUrl = mediaId ? `/api/SupportEngine/GetMedia/${mediaId}` : msg.vMediaUrl;

  const author = isAgent ? (msg.vCreatedUser || 'Agente') : null;
  const fromNumber = msg.vFromNumber || msg.fromNumber || null;

  return {
    isAgent,
    author,
    text,
    id,
    timeStr,
    isSticker,
    isImage,
    isAudio,
    isVideo,
    isDocument,
    isContact,
    mediaUrl,
    fromNumber
  };
};

/**
 * Formatea segundos a formato mm:ss para notas de voz
 * @param {number} sec 
 * @returns {string}
 */
export const formatAudioTime = sec => {
  if (!sec || isNaN(sec) || !isFinite(sec)) return '0:00';
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${s < 10 ? '0' : ''}${s}`;
};
